<div class="flex flex-col flex-[1] min-h-0">
  <div class="flex justify-between">
    <div class="flex items-center gap-[8px]">
      <div class="title">Members</div>
      <img
        src="/assets/svg/info.svg"
        width="16"
        height="16"
        matTooltip="Invite members and assign organizational roles (Admin/Member) and user roles. To create or edit user roles, go to Roles & Permissions."
        matTooltipClass="blue-md-tooltip wider"
      />
    </div>
    <div class="flex h-[35px]">
      @if (isAdmin()) {
        <button class="invite-btn" (click)="openInviteMemberDialog()">Invite Team Member</button>
      }
      @if (isAdmin()) {
        <div class="h-[100%] w-[1px] bg-[#ecf0f0] mx-[20px]"></div>
      }
      <div class="relative">
        <input
          class="w-[256px] h-[100%] text-[14px] px-[14px] pr-[33px] rounded-[17.5px] border border-solid border-[#d5d7db] outline-none placeholder:text-[#999]"
          type="text"
          placeholder="Search team members..."
          #searchInput
          (input)="searchText.set(searchInput.value)"
        />
        <img class="absolute right-[8px] top-[5px]" width="25" height="25" src="/assets/svg/search-blue.svg" />
      </div>
    </div>
  </div>
  <div class="mt-[18px] flex-[1] overflow-auto min-h-[200px]">
    @if (auth0Store.teamMembersLoading()) {
      <div class="pt-[35px] text-center">
        <gnx-dots-loader />
        <div>Loading team members</div>
      </div>
    }
    @if (auth0Store.teamMembersLoaded()) {
      @for (user of teamMembersData(); track user) {
        <div class="member group" [class.pointer-events-none]="user.loading">
          @switch (!!user.name) {
            @case (true) {
              <gnx-avatar class="mx-[16px] ml-[20px]" [bgColor]="'#007da8'" [size]="50" [name]="user.name" />
            }
            @case (false) {
              <div class="w-[50px] h-[50px] bg-[#007da8] rounded-[50%] mx-[23px] ml-[26px]"></div>
            }
          }
          <div class="flex flex-col flex-auto">
            <span class="name">{{ user.name }}</span>
            <span class="email">{{ user.email }}</span>
          </div>
          @if (showApplicativeRoles) {
            <div class="col-role">
              <mat-select
                [value]="user.applicative_role || ''"
                (selectionChange)="onApplicativeRoleChange(user, $event)"
                [disabled]="!isAdmin() || !auth0Store.applicativeRolesData()?.length"
                [class.no-roles]="isAdmin() && !auth0Store.applicativeRolesData()?.length"
                placeholder="Default Role"
              >
                @for (role of auth0Store.applicativeRolesData(); track role.role) {
                  <mat-option [value]="role.role">
                    {{ role.role | snakeCaseTitle }}
                  </mat-option>
                }
              </mat-select>
            </div>
          }
          <div class="col-c">
            <mat-select
              [value]="getOrgMemberRole(user)"
              (selectionChange)="onMemberRoleChange(user, $event)"
              [disabled]="!isAdmin()"
            >
              @for (type of USER_TYPE | keyvalue; track type) {
                <mat-option [value]="type.value">
                  {{ type.value }}
                </mat-option>
              }
            </mat-select>
          </div>
          <div class="col-d">
            @switch (user.status.toLowerCase()) {
              @case ('active') {
                <div class="active"><img height="12" src="/assets/svg/targeted.svg" />Active</div>
              }
              @case ('pending') {
                <div class="pending">
                  <img class="mr-[4px] align-bottom" width="18" height="18" src="/assets/svg/pending.svg" />Pending
                </div>
              }
            }
            @if (isAdmin()) {
              <img
                class="absolute right-[15px] opacity-0 group-hover:opacity-100 transition-opacity duration-150 cursor-pointer"
                src="/assets/svg/trash-can.svg"
                width="18"
                height="17"
                (click)="deleteMember(user)"
              />
            }
          </div>
          @if (user.loading) {
            <div class="w-[100%] h-[100%] absolute top-0 left-0 bg-[#d5d7db29]">
              <gnx-dots-loader class="align-center" />
            </div>
          }
        </div>
      }
      @if (!teamMembersData()?.length) {
        <div class="text-[18px]">No team members found</div>
      }
    }
    @if (!auth0Store.teamMembersLoading() && !auth0Store.teamMembersLoaded()) {
      <div>Error loading team members</div>
    }
  </div>
</div>
